var $ = global.jQuery = global.$;

var arrowInnerHtml = '<svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/assets/images/svg-defs-sprite.svg#arrow-down"></use></svg>';

var Field = require('./Field');

/**
 * Generates a basic custom select box
 * @class
 * @extends Field
 */
var CustomSelect = Field.extend(
  /** @lends CustomSelect.prototype */
  {
  /**
   * Initialises the widget
   * @private
   */
  init: function() {
    var self = this;
    var block = this.$el.attr('class');

    //Call the Field widgets own init method first
    this._super();

    this.$selectValue = $('<div class="' + block + '__value"></div>');
    this.$selectArrow = $('<div class="' + block + '__arrow">' + arrowInnerHtml + '</div>');

    this.$el.append(this.$selectValue);
    this.$el.append(this.$selectArrow);

    this.$select = this.$el.find('select');
    this.setFakeValue();

    this.$select.on('input change', this.setFakeValue.bind(this));
  },
  /**
   * Set/update the 'fake' value of the select
   */
  setFakeValue: function() {
    this.$selectValue.removeClass('is-empty-value');
    var selected = this.$select.children('option:selected');
    var selectedValue = selected.attr('value');
    var selectedText = selected.text();
    this.$selectValue.text(selectedText);
    if (selectedValue === '') this.$selectValue.addClass('is-empty-value');
  }
});

module.exports = CustomSelect;



/*****************
 ** WEBPACK FOOTER
 ** ./source/scripts/widgets/CustomSelect.js
 ** module id = 12
 ** module chunks = 0 1
 **/